export default __webpack_public_path__ + "static/media/82.0d73c690.gif";